import css from 'styled-jsx/css'
import { colors, common, sizes } from '../../theme'

export default css`
  .uptitle {
    display: block;
    ${common.h5}
    text-transform: uppercase;
    color: ${colors.yellow};
    margin-bottom: 3.5rem;
  }


  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .uptitle {
      ${common.h6}
    }
  }
`
